//--- React Libraries
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
//--- Ant Design
import { Card, Col, Row } from "antd";
//---Project
import { setSelectedHBTestId } from "reducers/eolTestsSlice";
import { heartBeatFactors } from "./heartBeatFactors";
import VehicleDetails from "components/Dashboard/VehicleDetails";
import HBHistoryPanel from "./HBHistoryPanel";
import HBResultPanel from "./HBResultPanel";
import HBTestSummary from "./HBTestSummary";
import NoData from "components/Common/NoData";
import HBDataLink from "components/Dashboard/EOL/Tests/Connectivity/Panels/HBDataLink";
import HBEolGraphPanel from "./HBEolGraphPanel";

const HeartBeatLayout = ({ onChangeImei, vehicle, showCommentModal }) => {
  const dispatch = useDispatch();
  const eol = useSelector((state) => state.eolTests);
  const vehicleSlice = useSelector((state) => state.eol);
  const vehicleDetails = vehicleSlice?.vehicleDetails;
  const selectedHBTestId = eol?.selectedHBTestId;
  const HBResultDetails = eol?.HBResultDetails;
  const HBTestRunningStatus = eol?.HBTestRunningStatus;

  useEffect(() => {
    dispatch(setSelectedHBTestId(vehicleDetails?.previousTests?.connectivity));
  }, [vehicleDetails, dispatch]);

  const graphOne = heartBeatFactors.graphs.filter(
    (graph) => graph.show === true
  )?.[0];
  const graphTwo = heartBeatFactors.graphs.filter(
    (graph) => graph.show === true
  )?.[1];

  return (
    <Row gutter={[16, 16]} className="mb1">
      <Col xs={24} sm={24} md={24} lg={6} xl={4}>
        <VehicleDetails
          onChangeImei={onChangeImei}
          imei={vehicle}
          cardHeight={"100%"}
        />
      </Col>
      <Col xs={24} sm={24} md={24} lg={18} xl={20}>
        <Row gutter={16} className="h100">
          <Col span={24}>
            <HBResultPanel showCommentModal={showCommentModal} />
          </Col>
        </Row>
      </Col>
      <Col xs={24} sm={24} md={24} lg={6} xl={4}>
        <HBHistoryPanel />
      </Col>

      <Col xs={24} sm={24} md={24} lg={18} xl={20}>
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={24} md={24} lg={6} xl={6}>
            <HBTestSummary />
          </Col>
          <Col xs={24} sm={24} md={24} lg={9} xl={9}>
            <Card
              title={graphOne.text}
              className="h100"
              extra={
                <div className="grid-data-link-box">
                  <HBDataLink
                    vIdVal={vehicle?.vehImei}
                    dataTable={graphOne.table}
                    field={graphOne.field}
                    testId={selectedHBTestId}
                    showErrors={false}
                  />
                </div>
              }
            >
              {HBResultDetails?.data ? (
                <HBEolGraphPanel
                  plotColor={HBTestRunningStatus ? "#56a64b" : "#40affe"}
                  panelSeries={graphOne.field}
                  panelField={graphOne.field}
                  panelTable={graphOne.table}
                  panelUnits={graphOne.unit}
                  showLive={HBTestRunningStatus}
                />
              ) : (
                <NoData />
              )}
            </Card>
          </Col>
          <Col xs={24} sm={24} md={24} lg={9} xl={9}>
            <Card
              title={graphTwo.text}
              className="h100"
              extra={
                <div className="grid-data-link-box">
                  <HBDataLink
                    vIdVal={vehicle?.vehImei}
                    dataTable={graphTwo.table}
                    field={graphTwo.field}
                    testId={selectedHBTestId}
                    showErrors={false}
                  />
                </div>
              }
            >
              {HBResultDetails?.data ? (
                <HBEolGraphPanel
                  plotColor={HBTestRunningStatus ? "#56a64b" : "#40affe"}
                  panelSeries={graphTwo.field}
                  panelField={graphTwo.field}
                  panelTable={graphTwo.table}
                  panelUnits={graphTwo.unit}
                  showLive={HBTestRunningStatus}
                />
              ) : (
                <NoData />
              )}
            </Card>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};
export default HeartBeatLayout;
